import CheckboxGroup from "../../../components/inputs/checkbox-group/checkbox-group";
import useCheckbox from "../hooks/use-checkbox";
import { useFormContext } from "../contexts/form-context";
import { useLayoutEffect, useEffect } from "react";
import { useTranslate } from "../../translation/hooks/use-translation";

const FormCheckboxGroup = (props) => {
  const { ref, bind } = useCheckbox(props);

  const { register, deregister, updateValidity } = useFormContext();
  const { getTranslatedProps } = useTranslate();

  const { translatedLabel, translatedOptions = [] } = getTranslatedProps(props);

  useLayoutEffect(() => {
    if (!props.ignore) {
      register(props.id || props.name, ref);

      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error])

  return (
    <CheckboxGroup
      {...props}
      {...bind}
      label={translatedLabel}
      options={translatedOptions}
    />
  );
};

export default FormCheckboxGroup;
